export function shareOnTwitter() {
    const baseLink = 'https://twitter.com/intent/tweet';
    const text = encodeURIComponent('Thunder Roads: \nVisualizing the 2021 Formula One Racing Season\n');
    const url = encodeURIComponent('https://f1.obumbratta.com/');
    window.open(
        `${baseLink}?text=${text}&url=${url}`,
        'twitter-share-dialog',
        'menubar=1,resizable=1,width=500,height=500'
    );
}

export function shareOnLinkedIn() {
    const baseLink = 'https://www.linkedin.com/shareArticle';
    const url = encodeURIComponent('https://f1.obumbratta.com/');
    const title = encodeURIComponent('Thunder Roads');
    const summary = encodeURIComponent('Visualizing the 2021 Formula One Racing Season');
    window.open(
        `${baseLink}?mini=true&url=${url}&title${title}&summary=${summary}`,
        'LinkedIn-share-dialog',
        'menubar=1,resizable=1,width=550,height=550'
    );
}

export function shareOnFacebook() {
    const baseLink = 'https://www.facebook.com/sharer/sharer.php';
    const url = encodeURIComponent('https://f1.obumbratta.com/');
    window.open(
        `${baseLink}?u=${url}`,
        'facebook-share-dialog',
        'menubar=1, resizable=1, width=626, height=550'
    );
}

export function shareOnClipboard() {
    navigator.clipboard.writeText('https://f1.obumbratta.com/');
}